import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import App from './App'
import router from './router'
import store from './store'

// Import all plugins
import 'plugins'

// vue-i18n needs to be passed to the vue Application, so we will import is here
import i18n from 'plugins/vue-i18n'

// Global styling for the shop
import '../assets/scss/style.scss'

sync(store, router)

const app = new Vue({
  router,
  store,
  i18n,
  ...App
})

export { app, router, store }



// WEBPACK FOOTER //
// ./client/app.js